export interface CSVExportData {
  headers: string[];
  rows: (string | number)[][];
  filename: string;
}

/**
 * CSV形式でデータをエクスポートする
 */
export const exportToCSV = (data: CSVExportData): void => {
  const { headers, rows, filename } = data;

  // CSVの内容を作成
  const csvContent = [
    headers.join(','),
    ...rows.map(row =>
      row
        .map(cell => {
          // 文字列の場合、カンマや改行を含む場合はダブルクォートで囲む
          if (
            typeof cell === 'string' &&
            (cell.includes(',') || cell.includes('\n') || cell.includes('"'))
          ) {
            return `"${cell.replace(/"/g, '""')}"`;
          }
          return cell;
        })
        .join(',')
    ),
  ].join('\n');

  // BOMを追加してExcelで文字化けを防ぐ
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  // ダウンロード処理
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * 日付を YYYY-MM-DD 形式でフォーマット
 */
export const formatDateForCSV = (date: string): string => {
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

/**
 * 金額を数値形式でフォーマット
 * @deprecated 新しいコードでは currencyFormatter.formatCurrencyForCSV を使用してください
 */
export const formatCurrencyForCSV = (amount: number): string => {
  return amount.toLocaleString('ja-JP');
};
